import { isAuthorizedUser } from 'shared/hooks/use-user'
import { UnauthorizedUser, UserInterface } from 'shared/types/user-interface'

// TODO: move to user hook https://app.shortcut.com/systeme/story/102621/inline-shouldshowchangepasswordpage-function
export const shouldShowChangePasswordPage = (
  user: UserInterface | UnauthorizedUser | undefined,
): boolean => {
  return isAuthorizedUser(user) && !user.impersonator
}
